import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className="policy">
      <h1>Contact Us</h1>
      <p>
        We&apos;re here to help with any questions about ViewEventNotes and our
        services.
      </p>

      <section>
        <h2>Customer Support</h2>
        <p>
          Email us anytime at:{' '}
          <a href="mailto:vieweventnotes@bungalow64.co.uk">
            vieweventnotes@bungalow64.co.uk
          </a>
        </p>
      </section>

      <section>
        <h2>Business Address</h2>
        <p>
          Bungalow64 Technologies Ltd
          <br />
          3 The Bungalows
          <br />
          Glusburn
          <br />
          BD20 8QQ
        </p>
      </section>

      <section>
        <h2>Response Times</h2>
        <p>
          We aim to respond to all support inquiries within 1-2 business days.
        </p>
      </section>
    </div>
  );
};

export default Contact;
